/* esm.sh - accessor-fn@1.5.3 */
var r=(function(n){return typeof n=="function"?n:typeof n=="string"?function(t){return t[n]}:function(t){return n}});export{r as default};
//# sourceMappingURL=accessor-fn.mjs.map